import {
    VOUCHER_PROVIDER_AMAZON, VOUCHER_PROVIDER_FREE,
    VOUCHER_PROVIDER_MOBILITY,
    VOUCHER_PROVIDER_PLATFORM,
    VOUCHER_STATUS_AVAILABLE,
    VOUCHER_STATUS_EXPIRED,
    VOUCHER_STATUS_ONHOLD,
    VOUCHER_STATUS_REFUNDED,
    VOUCHER_STATUS_USED
} from "./Constants";
import {useTranslation} from "react-i18next";
import {useTheme} from "@mui/material";



export const useStatusValuesVoucher = () => {
    const {t} = useTranslation(['salesmarketing']);
    const theme = useTheme();
    const getStatusColorVoucher = (status: string) => {
        switch (status) {
            case VOUCHER_STATUS_AVAILABLE: return theme.palette.success.transparent;
            case VOUCHER_STATUS_REFUNDED: return theme.palette.secondary.transparent;
            case VOUCHER_STATUS_USED: return theme.palette.warning.transparent;
            case VOUCHER_STATUS_EXPIRED: return theme.palette.error.transparent;
        }
    };

    const getStatusLabelVoucher = (status: string) => {
        switch (status) {
            case VOUCHER_STATUS_AVAILABLE: return t('voucher.statusValues.available');
            case VOUCHER_STATUS_REFUNDED: return t('voucher.statusValues.refunded');
            case VOUCHER_STATUS_USED: return t('voucher.statusValues.used');
            case VOUCHER_STATUS_EXPIRED: return t('voucher.statusValues.expired');
            case VOUCHER_STATUS_ONHOLD: return t('voucher.statusValues.onhold');
            case VOUCHER_PROVIDER_PLATFORM: return t('voucher.providersValues.platform');
            case VOUCHER_PROVIDER_MOBILITY: return t('voucher.providersValues.mobility');
            case VOUCHER_PROVIDER_AMAZON: return t('voucher.providersValues.amazon');
            case VOUCHER_PROVIDER_FREE: return t('voucher.providersValues.free')
            default : return '-'
        }
    };

    return {
        getStatusColorVoucher,
        getStatusLabelVoucher
    }
}